import type { ReactNode } from "react";
import { CHART_INK } from "./chartTheme";

export interface TooltipRow {
  /** Short stroke of the series colour — at tooltip density a filled box is too much ink. */
  color?: string;
  label: string;
  value: ReactNode;
}

/**
 * The hover readout every chart on the dashboard shares. The value leads and the series
 * name follows: the reader already knows which series they are pointing at, what they
 * want is the number. Tooltips enhance and never gate — every figure shown here is also
 * reachable from a direct label, an axis or the table beside the chart.
 */
export function ChartTooltip({ title, rows }: { title?: string; rows: TooltipRow[] }) {
  return (
    <div
      style={{
        background: CHART_INK.surface,
        border: `1px solid ${CHART_INK.gridline}`,
        borderRadius: 6,
        boxShadow: "0 2px 8px rgba(11, 11, 11, 0.08)",
        padding: "8px 10px",
        fontSize: 12,
        lineHeight: 1.5,
      }}
    >
      {title && <div style={{ color: CHART_INK.secondary, marginBottom: 4 }}>{title}</div>}
      {rows.map((row, i) => (
        <div key={i} style={{ display: "flex", alignItems: "center", gap: 8, whiteSpace: "nowrap" }}>
          {row.color && <span style={{ width: 10, height: 2, background: row.color, borderRadius: 1, flex: "none" }} />}
          <span style={{ color: CHART_INK.primary, fontWeight: 600 }}>{row.value}</span>
          <span style={{ color: CHART_INK.secondary }}>{row.label}</span>
        </div>
      ))}
    </div>
  );
}
